// extracted by mini-css-extract-plugin
export default {"text":"edit-cell_text__8LEc0","skeletonWrapper":"edit-cell_skeletonWrapper__wuAzp","date":"edit-cell_date__yTLaD"};